
import React from 'react';
import { OrderedArticleSummary } from '../../../lib/services/kypV3ApiService';

interface OrderedArticleReferencesListProps {
  articles: OrderedArticleSummary[];
}

export const OrderedArticleReferencesList: React.FC<OrderedArticleReferencesListProps> = ({ 
  articles 
}) => {
  if (!articles || articles.length === 0) {
    return (
      <div className="mt-4 pt-4 border-t border-gray-500">
        <h5 className="text-sm font-semibold text-[#CECFD2] mb-3">
          Article References
        </h5>
        <div className="bg-[#1A1A1A] rounded-lg p-4 border border-gray-500">
          <span className="text-sm text-gray-400">No article references available</span>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4 pt-4 border-t border-gray-500">
      <h5 className="text-sm font-semibold text-[#CECFD2] mb-3">
        Article References
      </h5>
      <div className="bg-[#1A1A1A] rounded-lg p-4 border border-gray-500">
        <div className="space-y-4">
          {articles.map((article) => (
            <div key={article.id} className="flex items-start gap-3">
              <span className="text-[#3d37cc] mt-0.5 text-sm font-semibold min-w-[20px]">
                {article.article_order}.
              </span>
              <div className="flex-1">
                <div className="text-sm text-[#CECFD2] leading-relaxed">
                  {article.summary_text}
                </div>
                <div className="mt-2 flex flex-wrap gap-4 text-xs text-gray-400">
                  {article.relevance_score && (
                    <span>Relevance: {(article.relevance_score * 100).toFixed(1)}%</span>
                  )}
                  {article.article_url && (
                    <a 
                      href={article.article_url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#3d37cc] hover:text-[#4E46FF] hover:underline transition-colors"
                    >
                      View Source
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
